import { render, staticRenderFns } from "./Fragen.vue?vue&type=template&id=b1421e0c&scoped=true&lang=html&"
import script from "./Fragen.vue?vue&type=script&lang=js&"
export * from "./Fragen.vue?vue&type=script&lang=js&"
import style0 from "./Fragen.vue?vue&type=style&index=0&id=b1421e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1421e0c",
  null
  
)

export default component.exports